import script from "./BookingOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingOption.vue?vue&type=script&setup=true&lang=ts"

import "./BookingOption.vue?vue&type=style&index=0&id=f2b9e8be&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2b9e8be"]])

export default __exports__